import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import CourseBanner from "../components/CourseBanner";
import OurServices from "../components/OurServices";
import NumbersSection from "../components/NumberSection";
import HomeCategories from "../components/HomeCategories";

const About = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const bannerData = {
    image: "/images/about-banner.jpg",
    heading: "About Us",
    para: "Welcome to Spectica, where vision meets style. As connoisseurs of eye care and fashion, we're dedicated to providing you with the highest quality eyewear that not only corrects and protects your vision but also enhances your individual style.",
  };
  return (
    <div className="page-content">
      <Helmet>
        <title>About Us</title>
        <meta
          name="description"
          content="
        and innovation."
        />
        <link rel="canonical" href="https://steamvarsity.com/about-us" />
      </Helmet>
   



      <div className="inner-banner-wrapper">
        <div className="banner">
          <img src="/images/about-us-banner.jpg" alt="About Us Banner" />
        </div>
      </div>

<section>
  <div className="container py-5"><div className="row d-flex justify-content-center">
    <div className="col-md-9">
      <div className="text text-center">
        <h1>About Integrated Interior</h1>
        <p>Integrated Interior is your trusted partner in creating spaces that truly reflect your vision and lifestyle. With a passion for design and a commitment to excellence, we specialize in transforming homes, offices, and retail spaces into stunning environments that combine functionality with aesthetics.</p>
        <p>Our team of skilled designers and craftsmen work closely with you to understand your needs, ensuring every project is a unique expression of your personality and purpose. From elegant home interiors to dynamic office spaces and inviting shop designs, we bring creativity and innovation to every corner.</p>
        
      </div>
      
      </div></div></div>
</section>

<NumbersSection />
    
      <section className="bg2">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-5">
              <div className="wrapper">
                <h2>Our Commitment to Quality</h2>

                <p>
               Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat rem perspiciatis aliquam molestiae id optio, eius at ipsum deleniti doloremque!

               
                </p>
               
              </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-6">
              <div className="img-wrapper">
                <img src="/images/team.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg2">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-5">
              <div className="wrapper">
                <h2>Our Vision</h2>

                <p>
                To be a leading name in the interior design and furniture industry, known for delivering timeless designs, impeccable craftsmanship, and customer satisfaction.
                </p>
               
              </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-6">
              <div className="img-wrapper">
                <img src="/images/team.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg2">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-5">
              <div className="wrapper">
                <h2>What Sets Us Apart</h2>

                <p>
                Choosing Integrated Interior means choosing a partner committed to excellence. Here’s why we stand out:</p>
<ul>
<li><b>Personalized Designs:</b> Tailored solutions that match your needs and preferences.</li>
<li><b>Experienced Team: </b>A skilled team of designers and craftsmen.</li>
<li><b>Premium Materials:</b> Only the best quality materials for durability and elegance.</li>
<li><b>Customer-Centric </b>Approach: We prioritize your satisfaction above all.</li>
<li><b>Timely Execution: </b>Projects delivered on schedule, every time.</li>

</ul>

              </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-6">
              <div className="img-wrapper">
                <img src="/images/team.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg2 py-5">
        <div className="container">
        <div className=" contact-card">
            <div className="wrapper">
            <div className="row">
                <div className="col-md-6">
                    
                        <div className="text-wrapper">
                            <h2 className="display-4 fw-bold mb-4">Connect with us</h2>

                            <p className="h4 mb-5">Good things happen when we connect.</p>
                            <a className="btn btn-black rounded-3" href="../contact-us/">Contact Us</a>

                        </div>
                   
                </div>
                <div className="col-md-6">
                    <div className="img-wrapper">
                        <img src="./images/office/customer-service.png" alt="" /> 
                    </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </section>
      

      <HomeCategories />
    </div>
  );
};

export default About;
